const getters = {
  // 获取售卖流程名称
  getSellName: (states) => (val) => {
    const r = states.sellTypeList.find(item => item.value == val);
    return r?.label;
  },
  // 获取购买成功引导类型名称
  getGuideName: (states) => (val) => {
    const r = states.guideTypeList.find(item => item.value == val);
    return r?.label;
  },
};
export default getters;
